/* Scroll reveal (design system web.md §11, bundle useReveal): content fades in and rises 16px over 600 ms, once.
   Marks [data-reveal] elements; reduced motion or no IntersectionObserver shows everything at once. */
(function () {
  function reduced() {
    try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) { return false; }
  }
  function init(root) {
    var els = (root || document).querySelectorAll("[data-reveal]:not(.fp-reveal)");
    if (!els.length) return;
    if (reduced() || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      // Content already in view on load is shown at once, so the first screen never waits on JS.
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add("is-in"); return; }
      el.classList.add("fp-reveal");
      io.observe(el);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
